"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var _types_1 = require("../../types");
exports.default = (_a = {},
    _a[_types_1.Network.arbitrumOne] = {
        POOL_FACTORY: "0xb4FD0Ce108e196d0C9844c48174d4C32Cd42F7bC",
    },
    _a[_types_1.Network.arbitrumGoerli] = {
        POOL_FACTORY: "0xB9d6b0D77Ed989Ec5879710cA5E4814f316c22b0",
    },
    _a[_types_1.Network.scrollL1Testnet] = {
        POOL_FACTORY: "0x4AE593b77234dB644a6d6443C89a447140aeb361",
    },
    _a[_types_1.Network.scrollL2Testnet] = {
        POOL_FACTORY: "0x4AE593b77234dB644a6d6443C89a447140aeb361",
    },
    _a[_types_1.Network.optimism] = {
        POOL_FACTORY: "0xb4FD0Ce108e196d0C9844c48174d4C32Cd42F7bC",
    },
    _a[_types_1.Network.optimismGoerli] = {
        POOL_FACTORY: "0x4AE593b77234dB644a6d6443C89a447140aeb361",
    },
    _a[_types_1.Network.aurora] = {
        POOL_FACTORY: "0xb4FD0Ce108e196d0C9844c48174d4C32Cd42F7bC",
    },
    _a[_types_1.Network.auroraTestnet] = {
        POOL_FACTORY: "0xB9d6b0D77Ed989Ec5879710cA5E4814f316c22b0",
    },
    _a);
